<template>
 <!-- 客房事件页面 -->
 <!-- 头部选择器 -->
 <div class="my-box">
  <el-card shadow="always" class="my-card topS">
   <el-form label-width="80px">
    <el-row :gutter="10" style="margin-bottom: 0">
     <el-col :span="4">
      <el-form-item label="品牌">
       <el-select v-model="searchForm.brandId" @change="selectOne" clearable filterable placeholder="请选择">
        <el-option v-for="(item,index) in brandSelectData" :key="index" :label="item.brandName" :value="item.id"></el-option>
       </el-select>
      </el-form-item>
     </el-col>
     <el-col :span="4">
      <el-form-item label="门店">
       <el-select v-model="searchForm.hotelId" clearable filterable placeholder="请选择">
        <el-option v-for="(item,index) in hotelSelectData" :key="index" :label="item.name" :value="item.id"></el-option>
       </el-select>
      </el-form-item>
     </el-col>
     <el-col :span="4">
      <el-form-item label="卡号">
       <el-input v-model="searchForm.cardSn" clearable></el-input>
      </el-form-item>
     </el-col>
     <el-col :span="4">
      <el-form-item label="卡类型">
       <el-select v-model="searchForm.cardType" clearable filterable placeholder="请选择">
        <el-option v-for="(item,index) in typeLists.cardTypes" :key="index" :label="item.label" :value="item.value"></el-option>
       </el-select>
      </el-form-item>
     </el-col>
     <el-col :span="4">
      <el-form-item label="姓名">
       <el-input v-model="searchForm.employeeName" clearable></el-input>
      </el-form-item>
     </el-col>

     <el-col :span="4">
      <el-form-item label="职位">
       <el-select v-model="searchForm.position" clearable filterable placeholder="请选择">
        <el-option v-for="(item,index) in typeLists.cardTypes" :key="index" :label="item.label" :value="item.value"></el-option>
       </el-select>
      </el-form-item>
     </el-col>

    </el-row>
    <el-row :gutter="10" style="margin-bottom: 0">
     <el-col :span="12">
      <el-button size="mini" type="primary" v-if="showAdd" @click="openpopup">添加</el-button>
      <el-button size="mini" v-if="showImport" @click="downDemo">下载模板</el-button>
      <el-upload v-if="showImport" :loading="downLoading" class="upload-demo" :http-request="UploadImage" action="#" accept=".xls,.xlsx" :before-upload="beforeUpload" :show-file-list="false" list-type="picture">
       <el-button size="mini">批量导入</el-button>
      </el-upload>
     </el-col>
     <el-col :span="12">
      <div class="grid-content reset-button">
       <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
       <el-button size="mini" @click="reset">重置</el-button>

      </div>
     </el-col>
    </el-row>

   </el-form>
  </el-card>
  <el-card>
   <el-table :data="tablist" v-loading="loading" id="tab" :height="height" style="width: 100%">
    <el-table-column v-for="(item,i) in execlTab" :key="i" :width="item.width" :prop="item.value" :label="item.label">
     <template slot-scope="scope">
      <div v-if="item.type=='operation'" class="operationBar">
       <div class="flex1">
        <el-button type="success" size="mini" v-if="showBan&&scope.row.cardSn&&scope.row.cardStatus==2" @click="setOpen(scope.row)">
         可用
        </el-button>
        <el-button type="info" size="mini" v-if="showBan&&scope.row.cardSn&&scope.row.cardStatus!=2" @click="setBan(scope.row)">
         禁用
        </el-button>
       </div>
       <div class="flex1">
        <el-button type="warning" size="mini" v-if="showUnbundle&&scope.row.employeeId&&scope.row.cardId" @click="unbundle(scope.row)">
         解绑
        </el-button>
       </div>
       <!-- <div class="flex1">
        <el-button type="success" size="mini" v-if="showScanQr&&!scope.row.openId" @click="OpsBindQr(scope.row)">
         授权
        </el-button>
       </div> -->
       <div class="flex1">
        <el-button type="primary" size="mini" v-if="showEdit" @click="edit(scope.row)">
         编辑
        </el-button>
       </div>
       <div class="flex1">
        <el-button type="danger" size="mini" v-if="showDel" @click="delStaff(scope.row)">
         删除
        </el-button>
       </div>

       <!-- <el-button  type="primary"  icon="el-icon-edit" size="mini" dialogFormVisible ></el-button> -->
      </div>
      <div v-else-if="item.solt_TEXT">
       {{showLabelText(scope.row[item.value],typeLists[item.solt_TEXT])}}
      </div>
      <div v-else-if="item.value=='opsAverageTime'">
       {{showLongTimes(scope.row.opsAverageTime)}}
      </div>
      <div v-else-if="item.value=='opsPercent'">
       {{scope.row[item.value]}}%
      </div>
      <div v-else>
       {{scope.row[item.value]}}
      </div>
     </template>
    </el-table-column>
   </el-table>
   <div class="page">
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next, sizes, total, jumper" :total="total">
    </el-pagination>
   </div>
  </el-card>
  <addView ref="add" :brandSelectData="brandSelectData" />
  <allOperation ref="allOperation" />
  <!-- <changeCard ref="changeCard" /> -->
  <importMessage ref="importMessage" :typeLists="typeLists" />
  <!-- <opsQr ref="opsQR" /> -->
 </div>
</template>
<script>
import { getLongDateTime, secondGetLongTime, showLabel } from "@/api/common.js";
import {
 workerList,
 workerUnbind,
 workerBan,
 getBrandSelect,
 getHotelSelect,
 workersDownTemplate,
 workerImport,
 workerDel
} from "@/api";
const typeLists = {};
import addView from "./addView";
import changeCard from "./changeCard";
import importMessage from "./importMessage";
import opsQr from "./opsQr";
import allOperation from "./allOperation";

export default {
 components: {
  addView,
  changeCard,
  importMessage,
  opsQr,
  allOperation
 },
 data() {
  return {
   height: null,
   tablist: [],

   execlTab: [
    {
     label: "品牌",
     value: "brandName",
    },
    {
     label: "门店",
     value: "hotelName",
     width: 280,
    },
    {
     label: "卡号",
     value: "cardSn",
    },
    {
     label: "卡类型",
     value: "cardType",
     solt_TEXT: "cardTypes",
    },
    {
     label: "员工姓名",
     value: "employeeName",
    },

    {
     label: "职位",
     value: "position",
     solt_TEXT: "cardTypes",
    },
    // {
    //  label: "权限",
    //  value: "checkout",
    // },
    {
     label: "创建日期",
     value: "createTime",
    },
    {
     label: "卡状态",
     value: "cardStatus",
     solt_TEXT: "cardStatus",
    },

    {
     label: "操作",
     type: "operation",
     width: 280,
    },
   ],
   loading: false,
   downLoading: false,
   // 查询的数据
   searchForm: {
    brandId: null,
    hotelId: null,
    cardSn: null,
    cardType: null,
    employeeName: null,
    position: null,
   },
   total: 0,
   pageNum: 1,
   pageSize: 10,
   listQuery: {},
   brandSelectData: null,
   hotelSelectData: null,
   startDateDisabled: {
    // 限制日期
    disabledDate: this.startDisabled,
   },
   endDateDisabled: {
    // 限制日期
    disabledDate: this.endDisabled,
   },
  };
 },
 beforeMount() {
  let h = document.documentElement.clientHeight || document.body.clientHeight;
  this.height = h - 295;
 },
 computed: {
  typeLists() {
   let obj = typeLists;
   obj.cardTypes = this.$store.state.cardTypes;
   obj.cardStatus = this.$store.state.cardStatus;
   return obj;
  },
  showImport: function () {
   return this.$store.state.roleMenu.includes("staffManage:import");
  },
  showAdd: function () {
   return this.$store.state.roleMenu.includes("staffManage:add");
  },
  showBan: function () {
   return this.$store.state.roleMenu.includes("staffManage:ban");
  },
  showUnbundle: function () {
   return this.$store.state.roleMenu.includes("staffManage:unbundle");
  },
  showEdit: function () {
   return this.$store.state.roleMenu.includes("staffManage:edit");
  },
  showScanQr: function () {
   return this.$store.state.roleMenu.includes("staffManage:scanQr");
  },
  showDel: function () {
   return this.$store.state.roleMenu.includes("staffManage:delete");
  },
 },

 created() {
  this.getList();
  this.initialize();
 },
 methods: {
  downDemo() {
   workersDownTemplate().then((res) => {
    var blob = new Blob([res.data], {
     type: "application/vnd.ms-excel",
    });
    var downloadElement = document.createElement("a");
    var href = window.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    downloadElement.download = "批量导入员工模板" + ".xlsx"; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放掉blob对象
   });
  },

  openpopup() {
   this.$refs.add.openSet();
  },
  UploadImage(e) {
   console.log(e, "UploadImage");
   console.log(e.file, "UploadImage");
   console.log(e.file.file, "UploadImage");
   this.downLoading = true;
   const formData = new FormData();
   formData.append("file", e.file); // 要提交给后台的文件
   //  formData.append("name", "批量取电卡"); // 这个接口必要的项目id
   console.log(formData);
   this.workerImportReq(formData);
  },
  workerImportReq(data) {
   workerImport(data)
    .then((res) => {
     console.log(res);
     if (res.data.code == "000000") {
      this.$refs.importMessage.open(res.data.data);
     } else {
      this.$message.error(res.data.message);
     }
    })
    .catch((err) => {
     console.log();
     this.$message.error("导入失败");
    });
  },
  beforeUpload(e) {
   var testmsg = e.name.substring(e.name.lastIndexOf(".") + 1);
   const extension = testmsg === "xls";
   const extension2 = testmsg === "xlsx";
   if (extension || extension2) return true;
   else this.$message.warning("只能上传xls/xlsx文件");
   return false;
  },
  startDisabled(t) {
   if (this.searchForm.endDate && t)
    return new Date(t).getTime() > new Date(this.searchForm.endDate).getTime();
   return false;
  },
  endDisabled(t) {
   if (this.searchForm.startDate && t)
    return (
     new Date(t).getTime() < new Date(this.searchForm.startDate).getTime()
    );
   return false;
  },
  // 根据值显示信息
  showLabelText(val, list) {
   return showLabel(val, list);
  },
  // 时长
  showLongTimes(val) {
   return secondGetLongTime(val);
  },
  edit(row) {
  //  this.$refs.changeCard.openSet(row);
   this.$refs.allOperation.openSet('edit',row);
  
  },
  OpsBindQr(row) {
    this.$refs.allOperation.openSet('opsQR',row);
  },
  unbundle(row) {
   this.$confirm("此操作将为该员工解绑, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
   })
    .then(() => {
     this.loading = true;
     workerUnbind({ employeeId: row.employeeId, cardId: row.cardId })
      .then((res) => {
       this.loading = false;
       if (res.data.code == "000000") {
        this.$message.success("解绑成功");
        this.getList();
       } else {
        this.$message.warning(res.data.message);
       }
      })
      .catch((err) => {
       this.loading = false;
       this.$message.warning("解绑失败");
      });
    })
    .catch(() => {});
  },
  delStaff(row){
    this.$confirm("此操作将删除该员工信息, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
   })
    .then(() => {
     this.loading = true;
     workerDel(row.employeeId).then((res) => {
       this.loading = false;
       if (res.data.code == "000000") {
        this.$message.success("删除成功");
        this.getList();
       } else {
        this.$message.warning(res.data.message);
       }
      })
      .catch((err) => {
       this.loading = false;
       this.$message.warning("删除失败");
      });
    })
    .catch(() => {});
  },
  setBan(row) {
   this.$confirm("此操作将该卡禁用, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
   })
    .then(() => {
     let data = {};
     data.brandId = row.brandId;
     data.hotelId = row.hotelId;
     data.cardSn = row.cardSn;
     data.cardStatus = 2;
     this.banReq(data);
    })
    .catch(() => {});
  },
  setOpen(row) {
   this.$confirm("此操作将该卡改为可用, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
   })
    .then(() => {
     let data = {};
     data.brandId = row.brandId;
     data.hotelId = row.hotelId;
     data.cardSn = row.cardSn;
     data.cardStatus = 1;
     this.banReq(data);
    })
    .catch(() => {});
  },
  banReq(data) {
   this.loading = true;
   workerBan(data)
    .then((res) => {
     this.loading = false;
     if (res.data.code == "000000") {
      this.$message.success("操作成功");
      this.getList();
     } else {
      this.$message.warning(res.data.message);
     }
    })
    .catch((err) => {
     this.loading = false;
     this.$message.warning("操作失败");
    });
  },
  initialize() {
   getBrandSelect().then((res) => {
    if (res.status === 200) {
     this.brandSelectData = res.data.data;
    }
   });
  },
  getSearchData() {
   this.listQuery = {};
   for (let key in this.searchForm) {
    if (this.searchForm[key] || this.searchForm[key] === 0) {
     this.listQuery[key] = this.searchForm[key];
    }
   }
  },
  // 获取门店下拉框 -- 2
  selectOne(id) {
   this.searchForm.hotelId = null;
   this.searchForm.roomNumber = null;
   this.hotelSelectData = null;
   getHotelSelect(id).then((res) => {
    if (res.data.data) {
     this.hotelSelectData = res.data.data;
    } else {
     this.$message({
      message: "该品牌下没有门店数据",
      type: "warning",
     });
    }
   });
  },
  // 搜索
  handleSearch() {
   this.pageNum = 1;
   this.getSearchData();
   this.getList();
  },
  // 重置
  reset() {
   this.pageNum = 1;
   this.searchForm = {
    brandId: null,
    hotelId: null,
    cardSn: null,
    cardType: null,
    employeeName: null,
    position: null,
   };
   this.getSearchData();
   this.getList();
  },
  handleSizeChange(val) {
   this.pageSize = val;
   this.getList();
  },
  handleCurrentChange(val) {
   this.pageNum = val;
   this.getList();
  },
  // 列表数据
  getList() {
   this.loading = true;
   workerList(this.pageNum, this.pageSize, this.listQuery)
    .then((res) => {
     this.loading = false;
     if (res.data.code == "000000") {
      this.tablist = res.data.data.rows;
      this.total = res.data.data.total;
     } else {
      this.$message.warning(res.data.message);
     }
    })
    .catch((err) => {
     this.loading = false;
    });
  },
 },
};
</script>
<style lang="scss" scoped >
.upload-demo {
 display: inline-block;
 margin-left: 10px;
}
.operationBar {
 display: flex;
}
.flex1 {
 flex: 1;
}

.my-box {
 .my-card {
  margin-bottom: 10px;
 }

 .el-row {
  margin-bottom: 10px;
  &:last-child {
   margin-bottom: 0;
  }
 }

 .grid-content {
  border-radius: 4px;
  height: 36px;
  white-space: nowrap;
  .el-input__inner {
   max-width: 190px;
  }
  span {
   font-size: 14px;
  }
 }

}
</style>


